import {
  fptiCustomImpression,
  fptiCustomSetup,
  fptiCustomClick,
  getFptiPage,
} from './fpti'
import serverData from './server-data'
import isFeatureEnabled, {
  getFeatureValue,
  isFeatureNotEnabled,
} from './remote-config'
import hasTreatmentName, { getTreatmentDataByName } from './treatment-name'
import { isEmail, isEmptyOrWhiteSpace } from './validation'
import { modalStyleConfig } from './modal'

const scrollToView = (domelement) => {
  setTimeout(() => {
    const element = document.querySelector(domelement)
    element.scrollIntoView({
      behavior: 'smooth',
    })
  }, 0)
}

export {
  fptiCustomImpression,
  fptiCustomClick,
  isFeatureEnabled,
  isFeatureNotEnabled,
  serverData,
  hasTreatmentName,
  getFptiPage,
  getTreatmentDataByName,
  getFeatureValue,
  fptiCustomSetup,
  isEmail,
  isEmptyOrWhiteSpace,
  modalStyleConfig,
  scrollToView,
}
